import { forwardRef } from 'react';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { Button } from '@mui/material';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function StatusSnackbar({ label, severity, open, setOpenAlert, needsAction, decreasePage }) {
    const handleClose = (event, reason) => {
        setOpenAlert(false);
    };

    return (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert
                onClose={handleClose}
                severity={severity}
                action={
                    needsAction ? (
                        <>
                            <Button
                                sx={{
                                    color: '#FFFFFF'
                                }}
                                size="small"
                                onClick={handleClose}>
                                Go Back
                            </Button>
                        </>
                    ) : null
                }>
                {label}
            </Alert>
        </Snackbar>
    );
}
